<template>
  <v-footer
    dark
    padless
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <div id="kontakty"></div>
      <!-- id="futer-card-partner-style" -->

      <v-list :class="`futer-card-partner-style ${PARTNER_CONFIG.theme_partner.futerContact}`">
        <!-- телефоны -->
        <div
          v-for="(phone,i) in PARTNER_CONFIG.partner_phone"
          :key="i"
        >
          <v-list-item>
            <v-list-item-action>
              <v-icon class="futer-icon-partner-style">mdi-phone</v-icon>

            </v-list-item-action>

            <v-list-item-content>

              <v-list-item-title>
                <a
                  class="phone-partner"
                  :href="`tel:${phone.phone}`"
                > {{phone.phone}}</a>

              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action :class="phone.hasViber"> <a
                class="phone-partner"
                :href="`viber://add?number=${phone.phone}`"
              >
                <v-icon class="futer-icon-partner-style">mdi-cellphone-message</v-icon>
              </a>
            </v-list-item-action>
          </v-list-item>
          <v-divider inset></v-divider>
        </div>

        <!-- /телефоны -->

        <v-list-item v-if="PARTNER_CONFIG.mail_partner.mail">
          <v-list-item-action>
            <v-icon class="futer-icon-partner-style">mdi-email</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{PARTNER_CONFIG.mail_partner.mail}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item v-if="PARTNER_CONFIG.addres_partner.adres">
          <v-list-item-action>
            <v-icon class="futer-icon-partner-style">mdi-map-marker</v-icon>
          </v-list-item-action>

          <v-list-item-content v-if="PARTNER_CONFIG.addres_partner.adres">
            <v-list-item-title>{{PARTNER_CONFIG.addres_partner.adres}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-card-title
        :class="`futer-tagline-partner-style mx-auto ${PARTNER_CONFIG.theme_partner.futerdown}` "
        width="100%"
      >
        <div
          width="100%"
          class="mx-auto lighten-2"
        >
          <h3 class="mx-auto text-center">
            {{PARTNER_CONFIG.tagline_partner.tagline}}</h3>
        </div>

        <div
          width="100%"
          class="mx-auto text-center"
        >
          <v-btn
            v-for="(social,i) in PARTNER_CONFIG.social"
            :key="i"
            class="mx-4 text-center"
            dark
            icon
          >
            <a
              class="phone-partner"
              :href="social.link"
            >
              <v-icon size="24px">{{ social.icon }}</v-icon>
            </a>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text :class="`py-2  text-center ${PARTNER_CONFIG.theme_partner.futerCopyrait}`">
        <strong>{{PARTNER_CONFIG.partner_name}}</strong> <br> {{ new Date().getFullYear() }}
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["PARTNER_CONFIG"])
  }
};
</script>



<style lang="css" scoped>
.phone-partner {
  color: #ffffff;
  text-decoration: none;
  flex: 1 1 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.noViber {
  display: none;
}

/* .futer-card-default-style {
  background-color: teal;
} */
</style>
